export default "__VITE_ASSET__YgI6cRp5__"